/* eslint-disable array-callback-return */
/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-use-before-define */
// eslint-disable-next-line simple-import-sort/imports
import {
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  FormControl,
  MenuItem,
  Theme,
  useMediaQuery,
} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Select from '@material-ui/core/Select';
import Typography from '@material-ui/core/Typography';
import { ContainerAdmin, MarginContainer, OaPopin } from '@orientaction/commons';
import {
  AdminTab,
  CreateEditAdmin,
  DrawerRight,
  Layout,
  ModalAdminUser,
  Search,
  SimpleModal,
} from '@orientaction/components';
import { useAdminUser, useAlert, useCompany, useOAMatch } from '@orientaction/hooks';
import { MajorTest, ResponseUser, userService } from '@orientaction/services';
import { getApiUrlByTestId, getFromLS, isMajorTest, updateUserInfoInLS } from '@orientaction/utils';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { publicSvgPath, publicLogoPath } from '../../utils/constants';
import AutoComplete from './AutoComplete';
import ListTabsAdmin from './ListTabsAdmin';
import style from './style';
import { apiServiceNative } from '../../utils/fetchNative';
import BeneficiaryFormCarte from '../../components/Form/CreateEditAdmin/BeneficiaryFormCarte';

import { getMe } from '../../services/user.service';
import { useLocation, useHistory } from 'react-router-dom';
import { useNavigation }  from '../../Context/NavigationContext';


const AdminUserResultat = () => {
  console.log('-');

  const {
    tabs,
    dialog,
    company,
    loading,
    actived,
    countTabs,
    textFilter,
    rattachement,
    currentPagination,
    setTabs,
    setCurrent,
    setCompany,
    setActived,
    oneComfirm,
    setCountTabs,
    setTextFilter,
    setOpenDrawer,
    handleCloseModal,
    setListUphierchy,
    setRattachement,
    getAdminUserList,
    setCurrentPagination,
    getAdminUserListZoneInfluance,
    reassignationErrorPopin,
    closeReassignationErrorPopin,
  } = useAdminUser();

  const { setOpenAlert, openSimpleAlert } = useAlert();

  const { search } = useLocation();
  const history = useHistory();

  const userConnected = JSON.parse(getFromLS('userInfos') || '{}');
  
  const { tab, search: lastSearch, page, setSearchTerm, setTab } = useNavigation();
  const [loadingGetHierachy, setLoadingGetHierachy] = useState<boolean>(false);
  
  const [hasSubordinate, setHasSubordinate] = useState<boolean>(false);

  const [typeTestChecked, setTypeTest] = useState(null);

  const [typeObjectValue, setObjectValue] = useState<any>(null);

  const [exportLoading, setExportLoading] = useState(false);

  const testFilters: any = useSelector((state: any) => state?.api?.testFilters);

  const testSelected: any = useSelector((state: any) => state?.api?.testSelected);

  const userTestFilters: any = useSelector((state: any) => state?.api?.userTestFilters);

  const classes = style();
  const isUserConsultant = userConnected?.company_user_role?.id === 4;
  const [openDraw, setOpenDraw] = useState<boolean>(false);

  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('xs'));

  const activateMatch = getFromLS('activateMatch') === 'true';
  const DISABLE_MATCH = process.env.REACT_APP_DISABLE_MATCH === 'true' && !activateMatch;

  const [openDialogOAMatch, setOpenDialogOAMatch] = useState<boolean>(false);
  const [modalConfirmationOA, setModalConfirmationOA] = useState<boolean>(false);
  const urlOAMatch = useCallback(() => {
    const token = getFromLS('userToken') || '';
    return `${process.env.REACT_APP_OA_MATCH_URL}/connexion/#token=${token}`;
  }, []);
  const [loadingPoppinsOAMatch, setLoadingPoppinsOAMatch] = useState<boolean>(false);
  const [textPoppinOAMatch, setTextPoppinOAMatch] = useState<any>({
    title: '',
    text: "Voulez-vous rejoindre Match le réseau social qui vous permettra d'échanger avec d'autres consultants ?",
    btnClose: 'Pas maintenant',
    btnAccess: 'Rejoindre',
  });

  const callBackDrawer = () => {
    setOpenDraw(false);
  };

  const { getCompanies, companies, getCompanyUserRole, companyUserRole, getPopulateHierachy } =
    useCompany();

  const getCompagnie = async () => {
    // get and set company data into the store
    await getCompanies();
  };

  const { verifyUser, signupToOAMatch } = useOAMatch();

  const token = getFromLS('userToken') || '';

  const getUserAdminByCompony_user_role = useCallback((data: any) => {
    setTabs(data);
    setCurrentPagination(0);
    setActived(true);
    setRattachement(true);
    setTab(data);
  }, []);

  // Memoized values start here
  // Get all tests for the first filter we use to filter response-user
  const alias = companies.find((item: any) => item.id === company);

  useMemo(() => {
    if (!dialog.open) {
      setHasSubordinate(dialog.open);
    }
  }, [dialog.open]);

  // useMemo(() => {
  //   const currentTab = new URLSearchParams(search).get('tab');
  //   if (currentTab) {
  //     getUserAdminByCompony_user_role(+currentTab);
  //   }
  // }, [search]);

  const getHierchyhasPopulate = async (id: number) => {
    setLoadingGetHierachy(true);

    try {
      const response: any = await getPopulateHierachy(id);

      setHasSubordinate(!!(response.length > 0));

      return response;
    } catch (err) {
      openSimpleAlert();
      throw err;
    } finally {
      setLoadingGetHierachy(false);
    }
  };

  useMemo(() => {
    if (dialog.open && dialog.type === 'delete') {
      getHierchyhasPopulate(+dialog.id);
    }
  }, [dialog.type, dialog.open]);

  // End of memoized values

  const getFirstAllData = (idCompany: number, roletype: string) => {
    setCountTabs({});
    setCurrentPagination(0);
    if (roletype !== 'admin' && tabs < 6) {
      setCompany({ target: { value: userConnected?.company?.id } });
      if (tabs === 1) {
        setTabs(userConnected?.company_user_role?.id + 1);
      } else {
        setTabs(tabs);
      }

      getAdminUserListZoneInfluance(
        userConnected.id,
        tabs,
        currentPagination,
        textFilter,
        actived,
        rattachement
      );
      return;
    }
    if (roletype === 'admin' && tabs < 6) {
      getAdminUserList(idCompany, tabs, currentPagination, textFilter, actived, rattachement);
    }
  };

  const addNewAdmin = () => {
    if (tabs === 5) {
      history.push('/admin/users-resultats/creer-beneficiaire');
      return;
    }

    history.push(`/admin/users-resultats/creer-consultant?role=${tabs}`);
  };

  const exportDataHandle = async () => {
    setExportLoading(true);
    try {
      const isTestMajor = isMajorTest(testSelected.id);
      if (isTestMajor) {
        const apiUrl = await getApiUrlByTestId(testSelected.id);
        MajorTest.getMajorTestResults(
          company,
          apiUrl,
          token,
          testFilters,
          {
            isRattached: userTestFilters.isRattached,
            isActive: userTestFilters.isActive,
          },
          'none',
          true
        );
      } else {
        ResponseUser.exportResponseUsers(
          token,
          testSelected.id,
          userTestFilters.isRattached,
          userTestFilters.isActive,
          testFilters
        );
      }
      setOpenAlert(
        true,
        `Vous allez recevoir un mail avec un lien pour télécharger l’export`,
        'info'
      );
    } catch (error) {
      openSimpleAlert(
        'Le filtre que vous avez sélectionné ne fonctionne pas avec les caractères que vous avez entrés.'
      );
    } finally {
      setExportLoading(false);
    }
  };

  const handleKeywordChange = (searchKeyword: string) => {
    if (searchKeyword === textFilter) {
      return;
    }
    setTextFilter(searchKeyword);
    setSearchTerm(searchKeyword);
  };

  const getCategoriesTest = async () => {
    const response = await apiServiceNative.get(`/api/category-tests?populate=tests`);
    sessionStorage.setItem('categories-test', JSON.stringify(response));
  };

  useEffect(() => {
    const fetchMe = async () => {
      const dataMe = await getMe(token);
      if (dataMe && dataMe.data) {
        if (!userConnected?.secondConnexion) {
          updateUserInfoInLS({ secondConnexion: true });
          setOpenDialogOAMatch(
            userConnected?.company_user_role?.id === 4 &&
              userConnected?.role?.type !== 'admin' &&
              (!userConnected?.statusOAMatchModal || userConnected?.statusOAMatchModal === 'none')
          );
        }
      }
    };
    getCompagnie();
    getCategoriesTest();
    fetchMe();
  }, []);

  useEffect(() => {
    getFirstAllData(company, userConnected?.role?.type);
  }, [company, tabs, userConnected?.role?.type, textFilter, actived, rattachement]);

  useEffect(() => {
    if (companyUserRole.length === 0) {
      getCompanyUserRole();
    }
    if (tab && userConnected?.role?.type === 'admin') setTabs(tab);
    if (lastSearch) {
      setTextFilter(lastSearch);
    }
    if (page) setCurrentPagination(page);
  }, []);

  const openDrawCarte = () => {
    setOpenDraw(true);
    const listEmpty = [];

    if (userConnected?.role?.type !== 'admin') {
      listEmpty.push({
        ...userConnected,
      });
    }

    setListUphierchy(listEmpty);
  };

  const updateViewOAMatchModal = async (status: string) => {
    try {
      updateUserInfoInLS({ statusOAMatchModal: status });
      await userService.modifyUser({
        token,
        statusOAMatchModal: status,
        id: userConnected?.id,
      });
    } catch (error) {
      console.log({ error });
    }
  };

  const closeModalOA = () => {
    setModalConfirmationOA(false);
    setOpenDialogOAMatch(false);
    updateViewOAMatchModal('refused');
  };

  const redirectToOAMatch = async () => {
    setLoadingPoppinsOAMatch(true);
    try {
      const userExist = await verifyUser(userConnected?.id?.toString());
      if (userExist) {
        window.open(urlOAMatch(), '_blank');
        updateViewOAMatchModal('accepted');
        setLoadingPoppinsOAMatch(false);
        setOpenDialogOAMatch(false);
        return;
      }
      const resp = await signupToOAMatch(userConnected);
      if (resp.data.addExternUser.code === 200) {
        setLoadingPoppinsOAMatch(false);
        setTextPoppinOAMatch({
          title: 'Votre compte est maintenant lié à Match',
          text: isMobile
            ? ''
            : 'Vous pouvez dès à présent vous connecter avec vos identifiants sur la page de connexion de Match.',
          btnClose: 'Fermer',
          btnAccess: 'Se connecter à Match',
        });
        updateViewOAMatchModal('accepted');
        // window.open(urlOAMatch(), '_blank');
      } else {
        setTextPoppinOAMatch({
          ...textPoppinOAMatch,
          title: 'Un problème est survenu',
          text: 'Veuillez retentez plus tard en passant par les boutons Match.',
        });
      }
    } catch (e) {
      setTextPoppinOAMatch({
        ...textPoppinOAMatch,
        title: 'Un problème est survenu',
        text: 'Veuillez retentez plus tard en passant par les boutons Match.',
      });
      setLoadingPoppinsOAMatch(false);
      console.log(e);
    }
  };

  const closeAndRedirect = () => {
    window.open(urlOAMatch(), '_blank');
    setOpenDialogOAMatch(false);
  };

  return (
    <Layout isaddBackground={true}>
      <MarginContainer>
        <div className={classes.bgGrey}>
          <MarginContainer>
            <ContainerAdmin rootStyleOverride={classes.overrideMargin}>
              <Grid
                container={true}
                spacing={2}
                direction="row"
                justifyContent="space-between"
                alignItems="center">
                <Grid item={true}>
                  <Typography
                    variant="h2"
                    style={{
                      color: '#0E1247',
                    }}
                    data-cy="text-admin">
                    {isUserConsultant ? 'Liste des bénéficiaires' : 'Utilisateurs et résultats'}
                  </Typography>
                </Grid>

                {userConnected?.role?.type === 'admin' && (
                  <Grid item={true}>
                    <Grid container={true} spacing={2} direction="row" alignItems="center">
                      <Grid item={true}>
                        <Typography
                          style={{
                            fontSize: '16px',
                            fontWeight: 'bold',
                            color: '#0E1247',
                          }}>
                          Espace entreprise sélectionné
                        </Typography>
                      </Grid>

                      <Grid item={true}>
                        <FormControl variant="outlined" style={{ minWidth: '25vh' }}>
                          <Select
                            labelId="demo-simple-select-outlined-label"
                            id="demo-simple-select-outlined"
                            value={company}
                            onChange={setCompany}
                            placeholder="Entreprise"
                            className={classes.formControlSelect}
                            data-cy="select-company">
                            {companies
                              .sort((a: any, b: any) => a.id - b.id)
                              .map((companyToShow: any, index: number) => {
                                return (
                                  <MenuItem
                                    value={companyToShow.id}
                                    key={companyToShow.id}
                                    data-cy={`company-${index}`}>
                                    {companyToShow.attributes.name}
                                  </MenuItem>
                                );
                              })}
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </ContainerAdmin>
          </MarginContainer>
        </div>

        <div>
          <ContainerAdmin rootStyleOverride={classes.overrideMargin}>
            <Grid container={true} justifyContent={isUserConsultant ? 'flex-end' : "space-between"} alignItems="center">
              <Grid
                item={true}
                lg={9}
                xl={9}
                md={9}
                sm={12}
                xs={12}
                style={isUserConsultant ? { display: 'none' } : undefined}>
                <AdminTab
                  callBack={getUserAdminByCompony_user_role}
                  countTabs={countTabs}
                  alias={alias}
                  viewDisable={!!actived}
                />
              </Grid>

              <Grid
                style={{ display: 'flex' }}
                item={true}
                lg={isUserConsultant ? 7 : 3}
                xl={isUserConsultant ? 7 : 3}
                md={isUserConsultant ? 7 : 3}
                sm={12}
                xs={12}>
                {tabs === 6 && (
                  <div className={classes.flexLine}>
                    <AutoComplete
                      setTypeTest={setTypeTest}
                      setObjectValue={setObjectValue}
                      typeObjectValue={typeObjectValue}
                      idCompany={company}
                      IfTabs={tabs === 6}
                    />
                    <Button
                      variant="outlined"
                      className={classes.btn}
                      disabled={exportLoading}
                      onClick={exportDataHandle}
                      data-cy="export-result">
                      <img
                        src={`${publicSvgPath}/vector.svg`}
                        alt="search icon"
                        style={{ marginRight: 10 }}
                      />
                      <span>{exportLoading ? 'Exporter...' : 'Exporter'}</span>
                    </Button>
                  </div>
                )}

                {isUserConsultant && (
                  <Button
                    onClick={openDrawCarte}
                    className={classes.btnPrimaryC}
                    style={{ textTransform: 'none' }}>
                    Inviter à passer des tests
                  </Button>
                )}

                <Search
                  isUserConsultant={isUserConsultant}
                  addNew={addNewAdmin}
                  isResult={!!(tabs === 6)}
                  wordFilter={textFilter}
                  handleFilterChange={handleKeywordChange}
                />
              </Grid>
            </Grid>
          </ContainerAdmin>

          <ContainerAdmin rootStyleOverride={classes.overrideMargin}>
            <ListTabsAdmin typeTestChecked={typeTestChecked} />
          </ContainerAdmin>
        </div>

        <CreateEditAdmin alias={alias} />

        <ModalAdminUser
          open={!!dialog.open}
          onCancel={handleCloseModal}
          onConfirm={oneComfirm}
          textCancel={dialog?.textCancel || 'Annuler'}
          title={dialog?.title || ''}
          textValidate={loading ? 'Chargemment ...' : dialog?.textBtn}
          type={dialog.type}
          loadingGetHierachy={loadingGetHierachy}
          hasSubordinate={hasSubordinate}>
          <div className={classes.modalContent}>
            <Typography variant="h6" className={classes.modalText}>
              {dialog?.paragraph || ''}
            </Typography>
          </div>
        </ModalAdminUser>
        <OaPopin
          open={reassignationErrorPopin}
          withCancel={false}
          title=""
          confirmText="OK"
          handleConfirm={closeReassignationErrorPopin}
          handleClose={closeReassignationErrorPopin}>
          <div className={classes.modalContent}>
            <Typography variant="h6" className={classes.modalText}>
              Vous ne pouvez pas réassigner tous les comptes de ce consultant : les prestations du
              nouveau consultant ne sont pas les mêmes
            </Typography>
          </div>
        </OaPopin>
      </MarginContainer>
      <DrawerRight
        openDrawer={openDraw}
        callBack={callBackDrawer}
        titleDrawer="Inviter à passer des tests">
        <BeneficiaryFormCarte
          closeDrawer={callBackDrawer}
          mode="create"
          companyUserRoleId={5}
          alias={alias}
        />
      </DrawerRight>
      {!DISABLE_MATCH && (
        <Dialog
          open={openDialogOAMatch}
          className={classes.modal}
          aria-labelledby="oa-common-popin">
          <DialogContent style={{ padding: 24 }}>
            <img
              src={`${publicLogoPath}/e-orientaction.png`}
              alt="logo-orientation"
              className={classes.logoImg}
            />
            {textPoppinOAMatch.title && (
              <p className={classes.textOADialog} style={{ fontSize: 22, fontWeight: 700 }}>
                {textPoppinOAMatch.title}
              </p>
            )}
            {loadingPoppinsOAMatch ? (
              <CircularProgress
                color="inherit"
                size={32}
                style={{ margin: 'auto', marginTop: 20, marginBottom: 20, display: 'block' }}
              />
            ) : (
              <p className={classes.textOADialog}>{textPoppinOAMatch.text}</p>
            )}

            <div style={{ width: '100%' }}>
              <Grid
                container={true}
                spacing={2}
                direction="row"
                justifyContent="center"
                alignItems="center">
                <Grid item={true} xs={6}>
                  <Button
                    variant="outlined"
                    className={classes.btnCancel}
                    onClick={() =>
                      textPoppinOAMatch?.title === '' ? closeModalOA() : setOpenDialogOAMatch(false)
                    }
                    style={{ textTransform: 'none', lineHeight: 1.1 }}>
                    {textPoppinOAMatch.btnClose}
                  </Button>
                </Grid>

                <Grid item={true} xs={6}>
                  <Button
                    id="confirmButton"
                    style={{ textTransform: 'none', background: '#000A8C', lineHeight: 1.1 }}
                    className={classes.btnConfirm}
                    onClick={() =>
                      textPoppinOAMatch?.title === '' ? redirectToOAMatch() : closeAndRedirect()
                    }
                    data-cy="btn-on-confirm-modal">
                    {textPoppinOAMatch.btnAccess}
                  </Button>
                </Grid>
              </Grid>
            </div>
          </DialogContent>
        </Dialog>
      )}
    </Layout>
  );
};

export default AdminUserResultat;
